export enum CreateFormSteps {
  ABOUT = 'ABOUT',
  SITUATION = 'SITUATION',
  FEATURES = 'FEATURES',
  PRIVACY = 'PRIVACY',
  PAGE = 'PAGE',
  FINISH = 'FINISH',
}
